import { Component, inject } from "@angular/core";
import { TargetModule } from "@enums/document/TargetModule";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { DocumentTemplatesPermissionModel } from "@models/permissions/DocumentTemplatesPermissionModel";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { MenuSystemDirective } from "@app/shared/directives/menu-system.directive";
import { DocumentTemplatesModuleComponent } from "./components/document-templates-module/document-templates-module.component";

@Component({
    selector: "document-templates-details",
    templateUrl: "./document-templates-details.component.html",
    styleUrls: ["./document-templates-details.component.scss"],
    imports: [MenuSystemDirective, DocumentTemplatesModuleComponent]
})
export class DocumentTemplatesDetailsComponent {
    protected tab: TabModel;

    protected permissions: DocumentTemplatesPermissionModel;

    protected TargetModule = TargetModule;
    protected permissionsService = inject(PermissionsService);

    constructor() {
        this.permissions = this.permissionsService.permissions.DocumentTemplates;
    }

    protected onSaved() {
        this.tab.refresh();
    }
}
